import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import { Accordion, AccordionDetails, AccordionSummary, Box, List, ListItemButton, ListItemText, Typography } from '@mui/material';
import React from 'react';
import { theme } from '../../../styles/theme';

function SearchEventsVendorCardComponent({ event }) {
    return (
        <Accordion
            square={true}
            sx={{
                borderRadius: 5,
                overflow: "hidden",
                "&:before": { display: "none" } // Removes the default divider line
            }}
        >
            {/* Accordion Header */}
            <AccordionSummary
                sx={{
                }}
                expandIcon={<ExpandMoreIcon className='manage-card-icon-circle' sx={{ color: theme.colors.events.primary }} />}>
                <Box>
                    <Box display={'flex'} alignItems={'center'} gap={1}>
                        <Typography variant='h6' color={theme.colors.events.black}>
                            {event.name}
                        </Typography>
                        <Typography variant='body2' color={'textSecondary'}>
                            • {Math.round(event.distance)} mi
                        </Typography>
                    </Box>
                    <Typography variant='body2' color={'textSecondary'}>
                        {new Date(event.start_time).toLocaleString(undefined, {
                            dateStyle: "medium",
                            timeStyle: "short"
                        })}
                    </Typography>
                </Box>
            </AccordionSummary>
            {/* Accordion Content */}
            <AccordionDetails sx={{ py: 0, mt: -2 }}>
                <Typography variant='body2' color='textPrimary' mt={1}>
                    {event.short_description || "No description"}
                </Typography>
                <List>
                    <ListItemButton component="a" href={`/event/${event.slug}`} target="_blank">
                        <ListItemText primary="🔗" sx={{ maxWidth: "35px" }} />
                        <ListItemText primary="Open Event Page" />
                        <OpenInNewIcon fontSize="small" sx={{ color: 'goldenrod' }} />
                    </ListItemButton>
                    <ListItemButton
                        component="a"
                        href={`https://www.google.com/maps?q=${event.location?.coordinates[1]},${event.location?.coordinates[0]}`}
                        target="_blank"
                    >
                        <ListItemText primary="🗺️" sx={{ maxWidth: "35px" }} />
                        <ListItemText primary="Show on Maps" />
                        <OpenInNewIcon fontSize="small" sx={{ color: 'goldenrod' }} />
                    </ListItemButton>
                </List>
            </AccordionDetails>
        </Accordion>
    );
}

export default SearchEventsVendorCardComponent;